import { useRef } from 'react';

import { useClientRepresentativeSaveAddresses } from 'api/requests';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { OnboardingRegistrationAddressFormType } from 'modules/onboarding/common/forms/onboardingRegistrationAddressForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/common/helpers/registrationAddress';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useRegistrationAddress = () => {
  const {
    error,
    loading: submitLoading,
    saveAddresses,
  } = useClientRepresentativeSaveAddresses();

  const { goToBack, goToNext, data } = useOnboardingContext();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialData = useRef(getInitialData(data.currentClient)).current;
  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData?.files);

  const onSubmit = async (values: OnboardingRegistrationAddressFormType) => {
    if (values) {
      const submitData = getSubmitData(values, true);
      await saveAddresses(data.currentClient.id, submitData);
      goToNext();
    }
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    countries,
    countriesLoading,
    submitLoading,
    files,
    submitDisabled,
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  };
};
